module.exports = __webpack_public_path__ + "static/media/2p.793d6747.png";